import React, { Fragment } from 'react';

import * as Actions from 'employees/components/list/actions';

const EmployeesActions = ({ company, subcompany, permissions, employee, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.employees.toggle'] && (
        <Actions.Toggle employee={employee} handleClick={handleToggle} />
      )}
      {permissions['acl.employees.update'] && (
        <Actions.Edit
          company={company}
          subcompany={subcompany}
          employee={employee}
          handleClick={handleToggle}
        />
      )}
    </Fragment>
  );
};

export default EmployeesActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/EmployeesActions.js